module.exports = __webpack_public_path__ + "static/media/add-logo-desktop-en.c2e2cc94.png";